/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_MetadataInputs */

const en_project_metadata = /** @type {(inputs: Project_MetadataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project Metadata`)
};

const fr_project_metadata = /** @type {(inputs: Project_MetadataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Métadonnées du projet`)
};

const de_project_metadata = /** @type {(inputs: Project_MetadataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projektmetadaten`)
};

const it_project_metadata = /** @type {(inputs: Project_MetadataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadati del progetto`)
};

const ru_project_metadata = /** @type {(inputs: Project_MetadataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Метаданные проекта`)
};

const es_project_metadata = /** @type {(inputs: Project_MetadataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadatos del proyecto`)
};

const zh_cn2_project_metadata = /** @type {(inputs: Project_MetadataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`项目元数据`)
};

const ja_project_metadata = /** @type {(inputs: Project_MetadataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクトメタデータ`)
};

const hi_project_metadata = /** @type {(inputs: Project_MetadataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`परियोजना मेटाडेटा`)
};

const pt_pt2_project_metadata = /** @type {(inputs: Project_MetadataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadados do projeto`)
};

/**
* | output |
* | --- |
* | "Project Metadata" |
*
* @param {Project_MetadataInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const project_metadata = /** @type {((inputs?: Project_MetadataInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_MetadataInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_project_metadata(inputs)
	if (locale === "de") return de_project_metadata(inputs)
	if (locale === "it") return it_project_metadata(inputs)
	if (locale === "ru") return ru_project_metadata(inputs)
	if (locale === "es") return es_project_metadata(inputs)
	if (locale === "zh-CN") return zh_cn2_project_metadata(inputs)
	if (locale === "ja") return ja_project_metadata(inputs)
	if (locale === "hi") return hi_project_metadata(inputs)
	if (locale === "pt-PT") return pt_pt2_project_metadata(inputs)
	return en_project_metadata(inputs)
});